import axios from '../axios'

const getStudentsApi = async (page, data) => { 
    return await axios.get("api/teacher/students?page=" + page, {params: data})
}

export default getStudentsApi
